import React from "react";
import {useFormik} from "formik";
import * as yup from "yup";
import MDBox from "../../../materialDashboard/components/MDBox";
import MDTypography from "../../../materialDashboard/components/MDTypography";
import MDInput from "../../../materialDashboard/components/MDInput";
import MDLoadingButton from "../../../components/MDLoadingButton";
import {CircularProgress} from "@mui/material";
import {useSendEmailConfirmationMutation} from "../query";
import {useTranslation} from "react-i18next";


const SendInstruction = () => {
    const {t} = useTranslation(['auth', 'validation']);
    const {mutateAsync, isLoading, isSuccess, isError} = useSendEmailConfirmationMutation();

    const formik = useFormik({
        initialValues: {
            email: '',
        }, validationSchema: yup.object({
            email: yup
                .string()
                .email(t('validation:email'))
                .required(t('validation:required')),
        }),
        onSubmit: async (values) => {
            await mutateAsync(values.email);
        },
    });

    if (isSuccess) {
        return <MDBox mb={2}>
            <MDTypography variant="body2" textAlign="center">
                {t('emailConfirmation.successMsg')}
            </MDTypography>
        </MDBox>
    }

    return <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
        {
            isError && <MDTypography color="error" align="center" variant="body2">
                {t('emailConfirmation.errorMsg')}
            </MDTypography>
        }
        <MDTypography variant="body2" mb={2}>
            {t('emailConfirmation.description')}
        </MDTypography>
        <MDBox mb={2}>
            <MDInput type="email"
                     label={t('emailConfirmation.email')}
                     name="email"
                     value={formik.values.email}
                     onChange={formik.handleChange}
                     error={formik.touched.email && Boolean(formik.errors.email)}
                     helperText={formik.touched.email && formik.errors.email}
                     fullWidth/>
        </MDBox>
        <MDBox mt={4} mb={1}>
            <MDLoadingButton variant="gradient"
                             color="info"
                             fullWidth
                             disabled={isLoading}
                             startIcon={isLoading ? <CircularProgress size={20} color="inherit"/> : null}
                             type="submit">
                {t('emailConfirmation.submit')}
            </MDLoadingButton>
        </MDBox>
    </MDBox>
}


export default SendInstruction;